import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Storyboard from '../../views/section/storyboard';

import FlapUtil from 'Utils/content/flap-util';
import SectionUtil from 'Utils/content/section-util';
import {
  getRelatedSectionsByIdKey,
  getFirstRelatedSectionByIdKey,
} from 'Utils/content/item-util';
import { fetchStoryboard } from '../../redux/actions/curator-pro/storyboard-actions';
import { RelatedSectionType } from 'Webapp/enums';

const mapStateToProps = ({ sections, curatorProStoryboard }, { section }) => {
  const currentSection = FlapUtil.sectionOrDefaults(
    FlapUtil.getSectionByRemoteId(section.remoteid, sections.entries),
  );
  const isLoading = SectionUtil.isSectionLoading(
    currentSection.requestedRemoteId,
    sections.loading,
  );

  const relatedArticlesSection = getFirstRelatedSectionByIdKey(
    section,
    sections.entries,
    RelatedSectionType.ARTICLES,
  );
  const topicSections = getRelatedSectionsByIdKey(
    section,
    sections.entries,
    RelatedSectionType.TOPICS,
  );

  return {
    items: currentSection.items,
    storyboardSkeleton: curatorProStoryboard.storyboard,
    isLoading,
    neverLoadMore: currentSection.neverLoadMore,
    relatedArticlesSection,
    relatedTopicsSections: topicSections,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchStoryboard }, dispatch);

const StoryboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Storyboard);

export default StoryboardContainer;
